import { createFileRoute } from '@tanstack/react-router';

import SettingsPage from '@/pages/settings/SettingsPage';
import { buildPageMeta } from '@/utils/seo';

const settingsTitle = 'Settings — Budgy';
const settingsDescription = 'Choose whether Budgy can use analytics cookies.';

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
  head: () => {
    const pageMeta = buildPageMeta({
      title: settingsTitle,
      description: settingsDescription,
      path: '/settings',
    });

    return {
      ...pageMeta,
      meta: [...pageMeta.meta, { name: 'robots', content: 'noindex, follow' }],
    };
  },
});
